import React from "react";
import { Check } from "lucide-react";

export function Crit({ ok, text, testid }) {
  return (
    <div data-testid={testid} className={`flex items-center gap-1.5 text-xs font-medium ${ok ? "text-[#2D6A4F]" : "text-[#9c968a]"}`}>
      <span className={`h-4 w-4 rounded-full flex items-center justify-center ${ok ? "bg-[#2D6A4F] text-white" : "bg-[#E5E0D8] text-[#9c968a]"}`}>
        <Check className="h-2.5 w-2.5" strokeWidth={3} />
      </span>
      {text}
    </div>
  );
}

export function Field({ icon: Icon, label, children }) {
  return (
    <div>
      <label className="block text-sm font-semibold text-[#5C574F] mb-1.5">{label}</label>
      <div className="relative">
        <Icon className="absolute left-3.5 top-1/2 -translate-y-1/2 h-5 w-5 text-[#9c968a]" />
        {children}
      </div>
    </div>
  );
}
